import React, { Component } from 'react';
import Headroom from 'react-headroom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Grid,
  Row,
  css,
  styled,
  withTheme,
  up,
  down,
  th,
} from '@smooth-ui/core-sc';
import HeaderLogo from 'theme/logo-hp.svg';
import { Lock } from 'styled-icons/boxicons-solid/Lock';

const CustomHeadroom = styled(Headroom)`
  .headroom {
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  .headroom--unfixed {
    position: relative;
    transform: translateY(0);
  }
  .headroom--scrolled {
    transition: transform 200ms ease-in-out;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-100%);
  }
  .headroom--pinned {
    position: fixed;
    transform: translateY(0%);
  }
`;

const HeaderWrapper = styled.div`
  background-color: ${th('primary')};
  width: 100%;
  display: flex;

  padding: 10px;

  ${up(
    'lg',
    css`
      height: 120px;
      padding: 0;
    `
  )};

  .sui-grid {
    display: flex;
  }

  .header-row {
    display: flex;
    justify-content: space-between;
    position: relative;
  }
`;

const LogoContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 50px;
  height: auto;
  justify-content: center;
  ${up(
    'lg',
    css`
      margin-left: 10px;
      width: 100px;
    `
  )}
  a {
    display: flex;
  }
  img {
    height: auto;
    width: 100%;
  }
`;

const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${up(
    'lg',
    css`
      display: flex;
      align-items: flex-end;
    `
  )}
`;

const LogoutContainer = styled.div`
  position: absolute;
  right: 2rem;
  top: 10px;

  a {
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ${down(
    'lg',
    css`
      display: none;
    `
  )}
`;

const IconLock = styled(Lock)`
  color: #fff;
  height: 18px;
  width: auto;
`;

class Header extends Component {
  render() {
    return (
      <header className="site-header">
        {/* Leave the above <header /> here, necessary to contain Headroom */}
        {/* Otherwise Headroom will wrap all sibling elements */}
        <CustomHeadroom disableInlineStyles downTolerance={10}>
          <HeaderWrapper className="header-wrapper">
            <Grid>
              <Row className="header-row">
                <LogoContainer>
                  <Link to="/">
                    <img src={HeaderLogo} alt="HP" />
                  </Link>
                </LogoContainer>
                <LogoutContainer>
                  {this.props.showLogoutInMenu && (
                    <Link to="/logout">
                      <IconLock /> Logout
                    </Link>
                  )}
                </LogoutContainer>
                <HeaderRightContainer>
                  {this.props.children}
                </HeaderRightContainer>
              </Row>
            </Grid>
          </HeaderWrapper>
        </CustomHeadroom>
      </header>
    );
  }
}

Header.propTypes = {
  children: PropTypes.node,
  showLogoutInMenu: PropTypes.bool,
};

Header.defaultProps = {
  children: undefined,
  showLogoutInMenu: undefined,
};

export default withTheme(Header);
